export default __webpack_public_path__ + "static/Mongorr-44e7df5c7085937570840102946ed2b8.jpg";